import { render, staticRenderFns } from "./presale.vue?vue&type=template&id=18209ba1&scoped=true"
import script from "./presale.vue?vue&type=script&lang=js"
export * from "./presale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18209ba1",
  null
  
)

export default component.exports